import { render, staticRenderFns } from "./properties-block-renderer.vue?vue&type=template&id=47a2334f"
import script from "./properties-block-renderer.vue?vue&type=script&lang=js"
export * from "./properties-block-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports